import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PrivacyPolicy/index.tsx");
